export const validIdMaker = () => {
  const claculateBikoret = (id: any) => {
    id = id.toString();
    if (id.length > 8) {
      throw "only put 8 digits in id and the Sifrat bikorted will be calculated automaticly";
    }
    // Pad string with zeros up to 8 digits
    id = id.length < 8 ? ("00000000" + id).slice(-9) : id;

    const sum = Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    });
    return (10 - (sum % 10)) % 10;
  };
  const rand8digits = Math.floor(Math.random() * 99999999);
  return rand8digits.toString() + claculateBikoret(rand8digits);
};



// WEBPACK FOOTER //
// ./src/app/_helpers/valid-id-maker.ts